module.exports = __webpack_public_path__ + "static/media/spasojeTim.42877db8.jpg";